import { render, staticRenderFns } from "./follow.vue?vue&type=template&id=97961e3a&scoped=true"
import script from "./follow.vue?vue&type=script&lang=ts"
export * from "./follow.vue?vue&type=script&lang=ts"
import style0 from "./follow.vue?vue&type=style&index=0&id=97961e3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97961e3a",
  null
  
)

export default component.exports